var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.9995 8v14.6667h-47.99999v-14.6667c0-1.7681.70237-3.46381 1.95261-4.71405 1.25028-1.25024 2.94598-1.95261 4.71408-1.95261h34.6666c.8755 0 1.7424.17243 2.5512.50747.8088.33503 1.5438.8261 2.163 1.44514.6189.61907 1.1101 1.354 1.445 2.16283.335.80885.5075 1.67576.5075 2.55122z",
    fill: "#fbd03d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.6662 1.33334c-1.7681 0-3.4638.70237-4.71408 1.95261-1.25024 1.25024-1.95261 2.94595-1.95261 4.71405v14.6667h10.14929l21.3334-21.33336z",
    fill: "#4ab89a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m55.9995 41.3333v14.6667c0 1.768-.7024 3.4637-1.9525 4.7141-1.2504 1.2502-2.9462 1.9526-4.7142 1.9526h-17.3333v-21.3334z",
    fill: "#e3e3e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m31.9995 41.3333v21.3334h-17.3333c-1.7681 0-3.4638-.7024-4.71408-1.9526-1.25024-1.2504-1.95261-2.9461-1.95261-4.7141v-14.6667z",
    fill: "#e3e3e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3328 56h-17.3333v6.6667h17.3333c1.768 0 3.4638-.7024 4.7142-1.9526 1.2501-1.2504 1.9525-2.9461 1.9525-4.7141v-6.6667c0 1.768-.7024 3.4638-1.9525 4.7142-1.2504 1.2501-2.9462 1.9525-4.7142 1.9525z",
    fill: "#b2b2b2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m7.99951 49.3333v6.6667c0 1.768.70237 3.4637 1.95261 4.7141 1.25028 1.2502 2.94598 1.9526 4.71408 1.9526h17.3333v-6.6667h-17.3333c-1.7681 0-3.4638-.7024-4.71408-1.9525-1.25024-1.2504-1.95261-2.9462-1.95261-4.7142z",
    fill: "#b2b2b2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.9995 41.3333v14.6667c0 1.768-.7024 3.4637-1.9525 4.7141-1.2504 1.2502-2.9462 1.9526-4.7142 1.9526h-17.3333v-21.3334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.9995 41.3333v21.3334h-17.3333c-1.7681 0-3.4638-.7024-4.71408-1.9526-1.25024-1.2504-1.95261-2.9461-1.95261-4.7141v-14.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.9995 22.6667h-23.99999v18.6666h23.99999z",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.9995 22.6667h-24v18.6666h24z",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.9995 8v14.6667h-47.99999v-14.6667c0-1.7681.70237-3.46381 1.95261-4.71405 1.25028-1.25024 2.94598-1.95261 4.71408-1.95261h34.6666c.8755 0 1.7424.17243 2.5512.50747.8088.33503 1.5438.8261 2.163 1.44514.6189.61907 1.1101 1.354 1.445 2.16283.335.80885.5075 1.67576.5075 2.55122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6663 33.3333h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.9995 33.3333h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.9995 54.6667h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.9995 49.3333h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6663 29.3333v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6663 48 8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.6663 48-8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.3462 14.6667v-5.33336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/icon-calculator.d58abc3cec8c59d8f4dfc55693c95a14.svg";
export { ForwardRef as ReactComponent };